import styles from './index.module.less';
import dynamic from 'next/dynamic';
import Header from './Cpns/Header';
import MainFunc from './Cpns/MainFunc';
const RichText = dynamic(() => import('./Cpns/RichText'), {
  ssr: false,
});
const SectionList = dynamic(() => import('./Cpns/SectionList'), {
  ssr: true,
});
import { useRef, useEffect, useState } from 'react';
const LeftFixed = dynamic(() => import('./Cpns/LeftFixed'), {
  ssr: false,
});
import React from 'react';
const Index: React.FC<any> = ({ data }) => {
  const smallRef = useRef<HTMLDivElement>(null);
  const [isSmallVisible, setIsSmallVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsSmallVisible(false);
          } else {
            setIsSmallVisible(true);
          }
        });
      },
      {
        threshold: 0.1, // 当元素10%可见时触发回调
      },
    );

    if (smallRef.current) {
      observer.observe(smallRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.big}>
        <ul className={styles.brumer}>
          <li>
            <a href={process.env.NEXT_APP_WEB_HOST}>Home</a>
          </li>
          <li>{'>'}</li>
          <li>
            <a href={process.env.NEXT_APP_WEB_HOST + '/guide'}>Guides</a>
          </li>
          <li>{'>'}</li>
          <li>{data.contentInfo['section-body'].title}</li>
        </ul>
        {isSmallVisible && <LeftFixed richText={data.contentInfo['section-body'].rich_text} />}
        <Header title={data.contentInfo['section-body'].title} desc={data.contentInfo['section-body'].desc} />
        <MainFunc />
        <RichText richText={data.contentInfo['section-body'].rich_text} />
      </div>
      <div className={styles.small} ref={smallRef}>
        {data?.pageList?.length > 0 && <SectionList data={data} />}
      </div>
    </div>
  );
};

export default Index;
